<template>
	<div id="body-container">
		<newNavBar />
		<div class="SessionPopup">
			<SessionPopup />
		</div>
		<div class="overlay" :class="{ active: 'isOverlayActive' }" v-if="isSessionPopupVisible == true"></div>
		<div class="content flex-1 w-full h-screen overflow-y-auto">
			<div class="page">
				<slot />
			</div>
			<Footer />
		</div>
	</div>
</template>
<style  scoped>
.page {
  margin-bottom: 0;
}
.SessionPopup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 999999; /* Ensure it's above other content */
}
.bg-dark.active {
  /* background-color:rgba(8, 8, 8, 0.5); */
  opacity:0.7;
  z-index:50;
}
.bg-dark-blue.active{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Black with opacity */
  z-index: 999997;
  display: none; /* Initially hidden */
}

.overlay.active {
  display: block; /* Show the overlay when active */
}
@media (max-width: 1024px) {
  .page {
    margin-bottom: 80px;
  }
}
</style>
 <script lang="ts">
import newNavBar from '@/components/newNavBar.vue';
import sidemenubar from '@/components/sidemenubar.vue';
import Footer from '@/components/newFooter.vue';
import { defineComponent } from 'vue';
import { emitter } from '../main';
import {mapGetters} from 'vuex';
import SessionPopup from '@/components/sessionpopup.vue';
export default defineComponent({
	components: {
		newNavBar,
		sidemenubar,
		Footer,
		SessionPopup
	},
	data() {
		return {
			isToggling: false,
			appsVisible:false,
			isSessionPopupVisible:false
		};
	},
	mounted() {
		emitter.off('sessionPopupVisible');
		emitter.on('sessionPopupVisible',(data:any)=>{			
		this.isSessionPopupVisible = data;			
		})
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
			this.isSessionPopupVisible = data;
		})
	},
	created() {
		emitter.off('sessionPopupVisible');
		emitter.on('sessionPopupVisible',(data:any)=>{			
		this.isSessionPopupVisible = data;			
		})
		emitter.on('isvisible',(data:any)=>{
			this.isSessionPopupVisible = data;
		})
	}
});
</script>